import React from 'react';
import HeroSection from '../components/HeroSection';
import DealStrip from '../components/DealStrip';
import TodaysDeals from '../components/TodaysDeals';
import PopularRoutes from '../components/PopularRoutes';
import HowItWorks from '../components/HowItWorks';
import Testimonials from '../components/Testimonials';
import CtaBanner from '../components/CtaBanner';
import SEO from '../components/SEO';

const jsonLd = {
  '@context':'https://schema.org','@type':'WebSite',name:'USAFlightsDeals',url:'https://usaflightsdeal.com',
  description:'Hunt the Deal. Book the Flight. Scan 150+ airlines for the biggest price drops on US flights updated every hour.',
  potentialAction:{'@type':'SearchAction',target:'https://usaflightsdeal.com/flights?origin={origin}&destination={destination}&date={date}&adults=1','query-input':'required name=origin required name=destination required name=date'},
};

export default function HomePage() {
  return (
    <div>
      <SEO canonical="/" description="Hunt the Deal. Book the Flight. USAFlightsDeals scans 150+ airlines every hour to surface the biggest price drops on US domestic and international flights — no booking fees." keywords="flight deals USA, cheap flights America, flight price drops, airline deals, domestic flight deals, flash flight sales, best airfare deals" jsonLd={jsonLd} />
      <HeroSection />
      <DealStrip />
      <TodaysDeals />
      <PopularRoutes />
      <HowItWorks />
      <Testimonials />
      <CtaBanner />
    </div>
  );
}
